module.exports = __webpack_public_path__ + "img/front.6c42288b.png";